export enum ChatThemes {
    DARK = 'dark',
    LIGHT = 'light',
}